import { useGameStore } from '../store';
import { playToggle, ensureAudioContext } from '../sounds';
import { trackEvent } from '../analytics';

export function Preferences() {
  const cellStateCycleEnabled = useGameStore((s) => s.cellStateCycleEnabled);
  const spanHintsEnabled = useGameStore((s) => s.spanHintsEnabled);
  const timerVisible = useGameStore((s) => s.timerVisible);
  const toggleCellStateCycle = useGameStore((s) => s.toggleCellStateCycle);
  const toggleSpanHints = useGameStore((s) => s.toggleSpanHints);
  const toggleTimerVisible = useGameStore((s) => s.toggleTimerVisible);
  const trainSettings = useGameStore((s) => s.trainSettings);
  const saveTrainSettings = useGameStore((s) => s.saveTrainSettings);

  return (
    <div className="top-bar-settings-section">
      <div className="top-bar-settings-section-title">Preferences</div>
      <div className="top-bar-settings-section-subtitle">
        Adjustable any time, even mid-game.
      </div>

      <button
        className="top-bar-setting-row"
        onClick={() => {
          ensureAudioContext();
          playToggle();
          const next = toggleTimerVisible();
          trackEvent('timer_toggle', { enabled: next });
        }}
      >
        <div className="top-bar-setting-info">
          <span className="top-bar-setting-label">Show Timer</span>
          <span className="top-bar-setting-desc">
            Display elapsed time during puzzles
          </span>
        </div>
        <div
          className={`top-bar-setting-toggle${
            timerVisible ? ' top-bar-setting-toggle--on' : ''
          }`}
          aria-hidden="true"
        >
          <div className="top-bar-setting-knob" />
        </div>
      </button>

      <button
        className="top-bar-setting-row"
        onClick={() => {
          ensureAudioContext();
          playToggle();
          const next = toggleCellStateCycle();
          trackEvent('cell_state_cycle_toggle', { enabled: next });
        }}
      >
        <div className="top-bar-setting-info">
          <span className="top-bar-setting-label">Cycle Cell States</span>
          <span className="top-bar-setting-desc">
            Fill taps cycle forward. Mark taps cycle backward.
          </span>
        </div>
        <div
          className={`top-bar-setting-toggle${
            cellStateCycleEnabled ? ' top-bar-setting-toggle--on' : ''
          }`}
          aria-hidden="true"
        >
          <div className="top-bar-setting-knob" />
        </div>
      </button>

      <button
        className="top-bar-setting-row"
        onClick={() => {
          ensureAudioContext();
          playToggle();
          const next = toggleSpanHints();
          trackEvent('span_hints_toggle', { enabled: next });
        }}
      >
        <div className="top-bar-setting-info">
          <span className="top-bar-setting-label">Span Hints</span>
          <span className="top-bar-setting-desc">
            Show minimum space each clue needs
          </span>
        </div>
        <div
          className={`top-bar-setting-toggle${
            spanHintsEnabled ? ' top-bar-setting-toggle--on' : ''
          }`}
          aria-hidden="true"
        >
          <div className="top-bar-setting-knob" />
        </div>
      </button>

      <button
        className="top-bar-setting-row"
        onClick={() => {
          ensureAudioContext();
          playToggle();
          saveTrainSettings({
            ...trainSettings,
            autoMark: !trainSettings.autoMark,
          });
          trackEvent('clue_progress_toggle', {
            enabled: !trainSettings.autoMark,
          });
        }}
      >
        <div className="top-bar-setting-info">
          <span className="top-bar-setting-label">Clue Progress</span>
          <span className="top-bar-setting-desc">
            Gray out completed clues
          </span>
        </div>
        <div
          className={`top-bar-setting-toggle${
            trainSettings.autoMark ? ' top-bar-setting-toggle--on' : ''
          }`}
          aria-hidden="true"
        >
          <div className="top-bar-setting-knob" />
        </div>
      </button>
    </div>
  );
}
